import React, { useState } from 'react';
import Icon from '../../../components/appIcon';
import Button from '../../../components/ui/button';

const BulkActionsBar = ({ 
  selectedCount, 
  onBulkIdentify, 
  onBulkMarkAsVisitor, 
  onBulkDismiss, 
  onBulkActivate,
  onBulkExport,
  onClearSelection ,
  handleBulkDelete
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(null);

  const handleBulkAction = async (action, actionType) => {
    setIsProcessing(true);
    try {
      await action();
      setShowConfirmation(null);
    } finally {
      setIsProcessing(false);
    }
  };

  const confirmAction = (actionType, action) => {
    setShowConfirmation({ type: actionType, action });
  };

  if (selectedCount === 0) return null;

  return (
    <>
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-1000">
        <div className="bg-card border border-border rounded-lg shadow-lg p-4 min-w-96">
          <div className="flex items-center justify-between">
            {/* Selection Info */}
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-2">
                <Icon name="CheckSquare" size={20} className="text-primary" />
                <span className="font-medium text-foreground">
                  {selectedCount} selected
                </span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearSelection}
                iconName="X"
                iconPosition="left"
              >
                Clear
              </Button>
            </div>

            {/* Bulk Actions */}
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => confirmAction('inactive', onBulkDismiss)}
                disabled={isProcessing}
                iconName="X"
                iconPosition="left"
              >
                Dismiss
              </Button>
              <Button
                variant="default"
                size="sm"
                onClick={() => confirmAction('active', onBulkActivate)}
                disabled={isProcessing}
                iconName="Check"
                iconPosition="left"
              >
                Activate
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => confirmAction('inactive', handleBulkDelete)}
                disabled={isProcessing}
                iconName="X"
                iconPosition="left"
              >
                Delete
              </Button>
              {/* <Button
                variant="outline"
                size="sm"
                onClick={onBulkExport}
                disabled={isProcessing}
                iconName="Download"
                iconPosition="left"
              >
                Export
              </Button> */}
            </div>
          </div>
        </div>
      </div>
      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-1010">
          <div className="bg-card border border-border rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-warning bg-opacity-20 rounded-full flex items-center justify-center">
                <Icon name="AlertTriangle" size={20} className="text-warning" />
              </div>
              <div>
                <h3 className="font-semibold text-lg text-foreground">
                  Confirm Bulk Action
                </h3>
                <p className="text-sm text-muted-foreground">
                  This action cannot be undone
                </p>
              </div>
            </div>

            <p className="text-foreground mb-6">
              Are you sure you want to {showConfirmation?.type} {selectedCount} selected detections?
            </p>

            <div className="flex justify-end space-x-3">
              <Button
                variant="outline"
                onClick={() => setShowConfirmation(null)}
                disabled={isProcessing}
              >
                Cancel
              </Button>
              <Button
                variant="default"
                onClick={() => handleBulkAction(showConfirmation?.action, showConfirmation?.type)}
                loading={isProcessing}
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActionsBar;